import { LoanTrancheDisbursementApplication } from "@/modules/application/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const LoanTrancheDisbursementApplicationPage = ({ isEdit, isCopy }: IOperationPageProps) => (
  <LoanTrancheDisbursementApplication isEdit={isEdit} isCopy={isCopy}/>
);
